import * as setup from '@/setup';
import Button from '@/objects/button';

/**
 * Disegna la scena di errore con grafica identica a GameOver
 * @param {Phaser.Scene} scene - La scena Phaser
 * @param {string} errorMessage - Il messaggio di errore da mostrare
 * @returns {Object} Oggetto con i riferimenti ai bottoni creati
 */
export var drawErrorScene = (scene, errorMessage) => {
	// Aggiungi layer trasparente (come GameOver)
	scene.add
		.graphics()
		.lineStyle(setup.styles.backgroundDitloide)
		.fillRect(0, 0, scene.sys.game.config.width, scene.sys.game.config.height)
		.setAlpha(0.5);

	// Aggiungi sfondo con l'immagine di errore (usa l'immagine lost del GameOver)
	scene.add.image(scene.sys.game.config.width / 2, scene.sys.game.config.height / 2, 'game-over-background-lost').setScale(0.7);

	// Mostra bottone RIPROVA (verde) - posizione simile a buttonPlay in GameOver
	let buttonRetry = new Button(
		scene,
		scene.sys.game.config.width / 2.8,
		scene.sys.game.config.height / 2 + setup.margin.buttonPlayMarginTop + 180 - 10,
		'green-button',
		0.4,
		'RIPROVA'
	);

	// Mostra bottone ESCI (rosso) - posizione simile a buttonQuit in GameOver
	let buttonQuit = new Button(
		scene,
		scene.sys.game.config.width / 1.6,
		scene.sys.game.config.height / 2 + setup.margin.buttonPlayMarginTop + 180 - 10,
		'red-button',
		0.4,
		'ESCI'
	);

	// Mostra titolo "ERRORE" - posizione simile al testo in GameOver
	scene.add
		.text(
			scene.sys.game.config.width / 2,
			scene.sys.game.config.height / 2 - 150,
			'ERRORE',
			{...setup.styles.gameOver.greetingStyle, fill: '#ff0000', fontSize: '48px', fontStyle: 'bold'}
		)
		.setOrigin(0.5);

	// Mostra messaggio di errore sotto il titolo
	scene.add
		.text(
			scene.sys.game.config.width / 2,
			scene.sys.game.config.height / 2 - 80,
			errorMessage,
			{...setup.styles.gameOver.greetingStyle, fill: '#1567a3', fontSize: '24px'}
		)
		.setOrigin(0.5);

	return { buttonRetry, buttonQuit };
};